import React, { useState, useRef, useEffect, useContext, useMemo } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Divider, FloatButton, Image, Input, message, Carousel, Space } from 'antd';
import './comom.scss'
import { Col, Row } from 'antd';
import { AppContext, channel } from '@utils/AppContext';
import API from '@api/api.js';
import eventBus from '@utils/eventBus';
import Waterfall from "@view/compoents/waterfall/waterfall";
import styles from './Login.module.scss'
import MemberPackage from '@view/compoents/memberPackage/memberPackage';
import Utils from '@utils/utils';
import InviteUserModal from '@view/compoents/inviteUserModal/inviteUserModal'
import VideoJS from '@view/compoents/VideoJS/VideoJS';
import { useTranslation } from "react-i18next";
import { HOME_PAGE_TYPE } from "@utils/CONST"
import OneTimePay from "@view/compoents/oneTimePay/oneTimePay";
import Customized from '@view/compoents/customized';
import dayjs from 'dayjs';
import CahsbackModal from './compoents/cashbackModal';
import { IMAGE_TYPE } from '@utils/CONST';

const GoTo = (props) => {
    const handleClicl = () => {
        props.onClick()
    }
    return (
        <Button
            onClick={handleClicl}
            className={`${styles.editBtn}`}
            type='text'
        >
            <span>{props.text || '去生成'}</span>
        </Button>
    )
}

const GoTo2 = (props) => {
    const handleClicl = () => {
        props.onClick()
    }
    return (
        <Button
            onClick={handleClicl}
            className={`${styles.editBtn} ${styles.editBtn2}`}
            type='text'
            style={{float: 'auto'}}
        >
            <span>{props.text || '去生成'}</span>
        </Button>
    )
}

const Bottom = (props) => {
    return (
        <>
            <Row className={styles.BottomPart1}>
                <Col span={9} xl={12}>
                    <i className={styles.logo2} onClick={() => props.toHome()}></i>
                </Col>
                <Col span={6} xl={6}>
                    <ul className={styles.BottomList}>
                        <li><a target='_blank' href="https://www.arcsoft.com.cn/corporate/about.html">关于我们</a></li>
                        <li><a target='_blank' href="https://www.arcsoft.com.cn/corporate/about.html">关于虹软</a></li>
                        <li><a target='_blank' href="https://www.arcsoft.com.cn/corporate/commuting.html">虹软文化</a></li>
                    </ul>
                </Col>
                <Col span={9} xl={6}>
                    <ul className={styles.BottomList}>
                        <li>联系我们</li>
                        <li><span>商务合作</span>PSAISales@arcsoft.com</li>
                        <li><span>推广合作</span>PSAImedia@arcsoft.com</li>
                        <li><span>电话</span> 0571-88218564</li>
                    </ul>
                </Col>
            </Row>
            <Divider />
            <div className={styles.BottomPart2}>
                <span>2024 虹软科技股份有限公司 版权所有</span>
                <a target='_blank' href='https://beian.miit.gov.cn/#/Integrated/recordQuery'>浙ICP备17021791号{window.location.href.indexOf('psai.cn') == -1 ? '-3' : '-5'}</a>
                <a target='_blank' href='https://beian.mps.gov.cn/#/query/webSearch?code=33010802013419'>
                    <img src={require('@assets/images/gongan.png')} />
                    <span>浙公网安备 33010802013419号</span>
                </a>
                <a target='_blank' href='/服务协议.htm'>服务协议</a>
                <a target='_blank' href='/隐私政策.htm'>隐私政策</a>
            </div>
            <p className={styles.BottomPart3}>
                网信大模型备&nbsp;&nbsp;&nbsp;ZheJiang-ArcMuseJiSuanJiShuYinQing-20240408号&nbsp;&nbsp;&nbsp;网信算备&nbsp;&nbsp;&nbsp;330108672588901240017号
            </p>
        </>
    )
}

const Page1 = (props) => {
    const { t, i18n } = useTranslation();

    return (
        <div className={styles.login_show_} id='firstView'>
            <p className={styles.l_title}>会员方案</p>
            <p className={styles.l_tip}>感谢您的支持，请选择购买适合您的虹豆套餐</p>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <MemberPackage payFunc={props.payClick} isBorder={true} />
                <Customized payFunc={props.payClick} />
                <OneTimePay isBorder={true} />
            </div>
        </div>
    )
}

const Page2 = () => {
    const [qrcodeVisible, setQrcodeVisible] = useState()

    return (
        <div className={`${styles.logo_main} ${styles.p3}`} id='firstView'>
            <div className={styles.logo_main_item}>
                <img src={require('@assets/images/benner01.png')} alt="" />
                <div className={styles.left_1}>
                    <p className={styles.left_1_title}>欢迎来到  PhotoStudio<span className="registered_trademark">®</span> AI</p>
                    <p className={styles.left_1_content}>PhotoStudio<span className="registered_trademark">®</span> AI 是虹软倾力打造的一款基于生成式人工智能技术的创新产品，旨在为商家提供卓越的商拍图生成与优化服务。</p>
                    <div className={styles.qrcode}>
                        <img onClick={() => setQrcodeVisible(true)} src={Utils.qrcodeCommunity} alt="扫码联系我们" />
                        <Image
                            style={{ display: 'none' }}
                            preview={{
                                getContainer: '#root',
                                visible: qrcodeVisible,
                                imageRender: () => (<img style={{ width: 400 }} src={Utils.qrcodeCommunity} alt="扫码联系我们" />),
                                toolbarRender: () => null,
                                onVisibleChange: (value) => setQrcodeVisible(value),
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.logo_main_item_we}>
                <p className={styles.title_we}>关于我们</p>
                <ul className={styles.item_we_ul}>
                    <li>PhotoStudio<span className="registered_trademark">®</span> AI 是虹软科技股份有限公司基于业内领先的前沿技术打造的智能商拍摄影软件。</li>
                    <li>它结合了虹软AIGC专属商拍摄影大模型和高性能控制引擎，能够模拟人类摄影师的眼光和技巧，为服装等商品赋予质感和美感。我们力图让PhotoStudio<span className="registered_trademark">®</span> AI 不仅能够生成独特的商拍图像，还能够根据用户的需求自定义调整和优化，确保每张图片都完美地传达服装等商品的特点和价值。</li>
                    <li>虹软（688088.SH）是计算机视觉行业领先的算法服务提供商及解决方案供应商，<br />是全球领先的计算机视觉人工智能企业，于2019年7月22日在上海证券交易所上市，是中国“科创”的代表性企业。</li>
                    <li>作为一家赋能全球客户的科技型公司，虹软秉持“成就客户、持续创新、追求卓越”这一品牌理念，<br />坚持以技术创新为核心驱动力，将计算机视觉与AI服务大众。</li>
                </ul>
                <p className={styles.title_we} style={{ marginTop: '125px' }} >区域办事处</p>
                <div className={styles.we_box}>
                    <img src={require('@assets/images/ditu.png')} alt="" />
                    <div className={styles.we_box_box}>
                        <p>杭州(总部)</p>
                        <ul>
                            <li>杭州市滨江区滨兴路392号</li>
                            <li>邮编：310052</li>
                            <li>TEL：0571-88218564</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Home = (props) => {
    const { updateGlobalHomePageType } = useContext(AppContext);
    const [videoListText, setVideoListText] = useState(['智能补光', '智能美化', '魔法擦除', '画质升级'])
    const [videoListVlaue, setVideoListVlaue] = useState('智能补光')
    const videoList = { '智能补光': 'light', '智能美化': 'beauty', '魔法擦除': 'remove', '画质升级': 'sr', '随心变形': 'transform' }
    const [isbanner2, setIsbanner2] = useState(false)
    const navigate = useNavigate();

    const videoTabChange = (text) => {
        setVideoListVlaue(text)
    }

    // useEffect(() => {
    //     setTimeout(() => {
    //         setIsbanner2(true)
    //     }, 2000)
    // }, [])
    const goTo = (value) => {
        Utils.useroplog(HOME_PAGE_TYPE.CLOTHING, 'function', 'navigation', { from: 'home' })
        document.title = 'PhotoStudio AI-AI模特'
        if (value == 'model') navigate("/home/homemain/model")
        else if (value == 'dressform') navigate("/home/homemain/dressform")
        else if (value == 'clothes') navigate("/home/homemain/clothes")
        else if (value == 'aiEdit') navigate("/home/homemain/aiEdit")
        Utils.clearAllTaskCache()
    }

    const { globalActivity } = useContext(AppContext)
    // 活动状态 0-未开始 1-进行中 2-已结束
    const ACTIVITY_240711_STATUS = useMemo(() => {
        if (!globalActivity) return 0
        const activity = globalActivity.ACTIVITY_240711
        // const now = dayjs('2024-07-14')
        const now = dayjs()
        const start = dayjs(activity.beginAt)
        const end = dayjs(activity.endAt)
        return now.isBefore(start) ? 0 : now.isAfter(end) ? 2 : 1
    })
    // 显示活动
    const ACTIVITY_240711_DISPALY = useMemo(() => {
        if (!globalActivity) return false
        const activity = globalActivity.ACTIVITY_240711
        // const now = dayjs('2024-07-14')
        const now = dayjs()
        const start = dayjs(activity.beginAt)
        return !(now.isBefore(start) || now.isAfter(activity.endAt.add(3, 'day')))
    })

    const moduleList = [{
        key: 'left',
        className: styles.module_left,
        list: [{
            key: 'clothes',
            title: '服饰版',
            desc: '海量AI模特随心选',
            className: styles.module_box_1,
            items: [{
                key: 'clothes',
                label: 'AI试衣',
                icon: require('@assets/images/icon_home_clothes.png'),
                icon_active: require('@assets/images/icon_home_clothes--actived.png'),
                href: '/home/homemain/clothes',
                onClick: e => { e.preventDefault(); props.selectTypeClick(IMAGE_TYPE.CLOTHES) }
            }, {
                key: 'model',
                label: 'AI模特',
                icon: require('@assets/images/icon_home_model.png'),
                icon_active: require('@assets/images/icon_home_model--actived.png'),
                href: '/home/homemain/model',
                onClick: e => { e.preventDefault(); props.selectTypeClick(IMAGE_TYPE.MODEL) } 
            }, {
                key: 'dressform',
                label: '鞋子上脚',
                icon: require('@assets/images/icon_home_shoes.png'),
                icon_active: require('@assets/images/icon_home_shoes--actived.png'),
                href: '/home/homemain/dressform',
                onClick: e => { e.preventDefault(); props.selectTypeClick(IMAGE_TYPE.SHOES) }
            }, {
                key: 'model_video',
                label: '模特视频',
                icon: require('@assets/images/icon_home_modelvideo.png'),
                icon_active: require('@assets/images/icon_home_modelvideo--actived.png'),
                href: '/home/homemain/model_video',
                onClick: e => { e.preventDefault(); props.selectTypeClick(IMAGE_TYPE.MODEL_VIDEO) }
            }]
        }, {
            key: 'commodity',
            title: '商品版', 
            desc: '海量场景，风格多变',
            className: styles.module_box_2,
            items: [{
                key: 'commodity',
                label: '商品图',
                icon: require('@assets/images/icon_home_commodity.png'),
                icon_active: require('@assets/images/icon_home_commodity--actived.png'),
                href: '/home/homemain/commodity',
                onClick: e => { e.preventDefault(); props.selectTypeClick(HOME_PAGE_TYPE.MERCHANDISE) }
            }, {
                key: 'unknow',
                label: '敬请期待',
                icon: null,
                href: '',
                onClick: e => { e.preventDefault() },
                noHover: true,
            }]
        }]
    }, {
        key: 'right',
        className: styles.module_right,
        list: [{
            key: 'aiedit',
            title: 'AI编辑',
            desc: '全方位提升商品质感',
            className: styles.aiModule,
            items: [{
                key: 'matting',
                label: '智能抠图',
                icon: require('@assets/images/icon_home_aiedit_matting.png'),
                icon_active: require('@assets/images/icon_home_aiedit_matting--actived.png'),
                href: '/home/homemain/aiEdit',
                onClick: e => goToAIEdit(e, 'matting')
            }, {
                key: 'magicErase',
                label: '魔法擦除',
                icon: require('@assets/images/icon_home_aiedit_magicErase.png'),
                icon_active: require('@assets/images/icon_home_aiedit_magicErase--actived.png'),
                href: '/home/homemain/aiEdit',
                onClick: e => goToAIEdit(e, 'magicErase')
            }, {
                key: 'imageUpgrade',
                label: '画质升级',
                icon: require('@assets/images/icon_home_aiedit_imageUpgrade.png'),
                icon_active: require('@assets/images/icon_home_aiedit_imageUpgrade--actived.png'),
                href: '/home/homemain/aiEdit',
                onClick: e => goToAIEdit(e, 'imageUpgrade')
            }, {
                key: 'filllight',
                label: '智能补光',
                icon: require('@assets/images/icon_home_aiedit_filllight.png'),
                icon_active: require('@assets/images/icon_home_aiedit_filllight--actived.png'),
                href: '/home/homemain/aiEdit',
                onClick: e => goToAIEdit(e, 'filllight')
            }, {
                key: 'beautify',
                label: '智能美化',
                icon: require('@assets/images/icon_home_aiedit_beautify.png'),
                icon_active: require('@assets/images/icon_home_aiedit_beautify--actived.png'),
                href: '/home/homemain/aiEdit',
                onClick: e => goToAIEdit(e, 'beautify')
            }, {
                key: 'filter',
                label: '滤镜',
                icon: require('@assets/images/icon_home_aiedit_filter.png'),
                icon_active: require('@assets/images/icon_home_aiedit_filter--actived.png'),
                href: '/home/homemain/aiEdit',
                onClick: e => goToAIEdit(e, 'filter')
            }]
        }]
    }]

    const goToAIEdit = (e, menuKey) => {
        e.preventDefault()
        updateGlobalHomePageType(HOME_PAGE_TYPE.CLOTHING)
        if (menuKey == 'matting') navigate("/home/image_extraction")
        else navigate("/home/homemain/aiEdit", { state: { menuKey: menuKey } })
    }

    return (
        <div className={`${styles.logo_main} ${styles.p1}`} id='firstView'>
            <div className={`${styles.logo_main_item} ${styles.logo_main_item1}`}>
                <Carousel autoplay autoplaySpeed={4000}>
                    {
                        ACTIVITY_240711_DISPALY &&
                        <div className={styles.CarouselContent}>
                            <ActivityBanner selectTypeClick={props.selectTypeClick} />
                        </div>
                    }
                    <div className={styles.CarouselContent}>
                        <div className={`${styles.carousel_banner} ${styles.banner1}`}>
                            <Image
                                className={styles.CaseCard}
                                width={"100%"}
                                height={"100%"}
                                preview={false}
                                src={require('@assets/images/banner01@2x.png')}
                                placeholder={
                                    <Image
                                        width={"100%"}
                                        height={"100%"}
                                        preview={false}
                                        src={require('@assets/images/banner01@2x_blur.png')}
                                    />
                                }
                            />
                        </div>
                    </div>
                    {
                        ACTIVITY_240711_STATUS != 1 &&
                        <div className={styles.CarouselContent}>
                            <InviteBanner selectTypeClick={props.selectTypeClick} />
                        </div>

                    }
                </Carousel>
            </div>

            <div className={styles.module_box}>
                {
                    moduleList.map(group => (
                        <div key={group.key} className={group.className}>
                            {
                                group.list.map(item => (
                                    <div key={item.key} className={`${styles.module_box_item} ${item.className}`}>
                                        <div className={styles.module_content}>
                                            <div className={styles.module_text}>
                                                <p className={styles.module_title}>{item.title}</p>
                                                <p className={styles.module_desc}>{item.desc}</p>
                                            </div>
                                            <div className={styles.module_list}>
                                                {item.items.map(route => (
                                                    <a
                                                        key={route.key}
                                                        href={route.href}
                                                        onClick={route.onClick}
                                                        className={`${route.noHover && styles.noHover}`}
                                                    >
                                                        {route.icon && <img className={styles.icon} src={route.icon} />}
                                                        {route.icon_active && <img className={styles.icon_active} src={route.icon_active} />}
                                                        <span>{route.label}</span>
                                                        {route.key == 'matting' && <div className={styles.BatchIcon}><span>批量</span></div>}
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>
            <div className={styles.main_video_box}>
                <p>颠覆传统商拍</p>
                <p>PSAI模特场景不受限</p>
                <div style={{ marginTop: '1rem' }}>
                    <VideoJS
                        style={{ borderRadius: 32, overflow: 'hidden' }}
                        options={{
                            autoplay: true,
                            muted: true,
                            controls: false,
                            responsive: true,
                            fluid: true,
                            loop: true,
                            disablePictureInPicture: true,
                            poster: require(`@assets/video/cover/mainVideo.png`),
                            sources: [{
                                src: '/static/video/mainVideo/index.m3u8?t=1704876011761',
                                type: 'application/x-mpegURL'
                            }, {
                                src: require('@assets/video/mainVideo.mp4'),
                                type: 'video/mp4'
                            }]
                        }}
                    />
                </div>
                <p>AI模特随心替换</p>
                <p>覆盖不同人种、年龄、风格的模特库，可满足不同受众群体的审美偏好</p>
            </div>
            <div className={styles.middle_box}>
                <div className={styles.middle_box_left}>
                    <p className={styles.p1}></p>
                    <p className={`${styles.p2} ${styles.p2_model}`}>不再局限拍摄实景<br />与模特类型</p>
                    <p className={styles.p3} style={{ marginBottom: '.25rem' }}>任意真人照片即可生成不同地域，不同场景，不同模特类型的商拍大片</p>
                    <GoTo onClick={() => goTo('model')} />
                </div>
                <div className={styles.middle_box_right}>
                    <Image
                        className={styles.middle_box_img}
                        preview={false}
                        src={require('@assets/images/Figure1.png')}
                        placeholder={
                            <Image
                                className={styles.middle_box_img}
                                preview={false}
                                src={require('@assets/images/Figure1_blur.png')}
                            />
                        }
                    />
                </div>
            </div>

            <div className={styles.middle_box}>
                <div className={styles.middle_box_left}>
                    <Image
                        className={styles.middle_box_img}
                        preview={false}
                        src={require('@assets/images/Figure2.png')}
                        placeholder={
                            <Image
                                className={styles.middle_box_img}
                                preview={false}
                                src={require('@assets/images/Figure2_blur.png')}
                            />
                        }
                    />
                </div>
                <div className={styles.middle_box_right}>
                    <div style={{ width: ' 5.98rem' }}>
                        <p className={`${styles.p1} ${styles.p1_dressform}`}></p>
                        <p className={`${styles.p2} ${styles.p2_dressform}`}>无需模特，人台也是明星</p>
                        <p className={styles.p3} style={{ marginBottom: '.25rem' }}>只需拍摄人台照片，自动生成高清模特图，让商品瞬间闪耀</p>
                        <GoTo2 onClick={() => goTo('dressform')} />
                    </div>
                </div>
            </div>
            <div className={styles.middle_box}>
                <div className={styles.middle_box_left}>
                    <p className={`${styles.p1} ${styles.p1_tryon}`}></p>
                    <p className={`${styles.p2} ${styles.p2_tryon}`}>服装图片秒上身<span></span></p>
                    <p className={styles.p3} style={{ marginBottom: '.25rem' }}>只需上传商品平铺/挂拍图，即可生成堪比实景拍摄的高清模特图</p>
                    <br />
                    <GoTo onClick={() => goTo('clothes')} />
                </div>
                <div className={styles.middle_box_right}>
                    <Image
                        className={styles.middle_box_img}
                        preview={false}
                        src={require('@assets/images/Figure3.png')}
                        placeholder={
                            <Image
                                className={styles.middle_box_img}
                                preview={false}
                                src={require('@assets/images/Figure3_blur.png')}
                            />
                        }
                    />
                </div>
            </div>
            <div className={styles.main_title}>
                <p>包罗万象的AI编辑</p>
                <p>提供多种Al图像编辑模块，精心雕琢您的服装图片，全方位提升您的服装质感</p>
            </div>
            <div className={styles.video_list}>
                <div className={styles.videoBtn}>
                    {
                        videoListText.map((item) => (
                            <Button
                                key={item}
                                onClick={() => videoTabChange(item)}
                                shape="round"
                                type={videoListVlaue == item && 'primary'}
                                size='large'
                            >
                                {item}</Button>
                        ))
                    }
                </div>
                <div style={{ width: '100%' }}>
                    <VideoJS
                        style={{ borderRadius: 32, overflow: 'hidden' }}
                        options={{
                            autoplay: true,
                            muted: true,
                            controls: false,
                            responsive: true,
                            fluid: true,
                            loop: true,
                            disablePictureInPicture: true,
                            poster: require(`@assets/video/cover/${videoList[videoListVlaue]}.png`),
                            sources: [{
                                src: `/static/video/${videoList[videoListVlaue]}/index.m3u8?t=1704876011761`,
                                type: 'application/x-mpegURL'
                            }, {
                                src:          require(`@assets/video/${videoList[videoListVlaue]}.mp4`),
                                type: 'video/mp4'
                            }]
                        }}
                    />
                    <p style={{display: 'flex', justifyContent: 'center', marginTop: '40px'}}>
                    <GoTo text={"去编辑"} onClick={() => goTo('aiEdit')} />

                    </p>
                </div>
            </div>
            <div className={styles.main_title}>
                <p>案例图片</p>
            </div>
            <Waterfall />
            {
                !localStorage.getItem('token') &&
                <div className={styles.login_input_}>
                    <Space.Compact className={styles.left_4}>
                        <>
                            <Input placeholder="请输入手机号即可注册" value={props.mobile} onChange={(e) => props.setMobile(e.target.value)} />
                            <Button onClick={props.loginClick} type="primary">免费试用</Button>
                        </>
                    </Space.Compact>
                </div>
            }
        </div>
    )
}

const ActivityBanner = (props) => {
    const { globalActivity } = useContext(AppContext)
    const beginAt = useMemo(() => {
        return globalActivity ? globalActivity.ACTIVITY_240711.beginAt.format('YYYY MM.DD') : '-'
    }, [globalActivity])
    const endAt = useMemo(() => {
        return globalActivity ? globalActivity.ACTIVITY_240711.endAt.format('YYYY MM.DD') : '-'
    }, [globalActivity])

    return (
        <div className={`${styles.carousel_banner} ${styles.banner3}`}>
            <div className={styles.ActivityBanner}>
                <Image
                    className={styles.CaseCard}
                    width={"100%"}
                    height={"100%"}
                    preview={false}
                    src={require('@assets/images/banner03@2x.png')}
                    placeholder={
                        <Image
                            width={"100%"}
                            height={"100%"}
                            preview={false}
                            src={require('@assets/images/banner03@2x_blur.png')}
                        />
                    }
                />
                <p>邀请新用户</p>
                <p>百元现金真的领</p>
                <p>活动时间：{beginAt} - {endAt}</p>
            </div>
            {
                localStorage.getItem('channel') == 'taobao' ?
                    null :
                    <div className={styles.bth} onClick={() => props.selectTypeClick('cashbackActivity')}></div>
            }
        </div>
    )
}

const InviteBanner = (props) => {
    return (
        <div className={`${styles.carousel_banner} ${styles.banner2}`}>
            <Image
                className={styles.CaseCard}
                width={"100%"}
                height={"100%"}
                preview={false}
                src={require('@assets/images/banner02@2x.png')}
                placeholder={
                    <Image
                        width={"100%"}
                        height={"100%"}
                        preview={false}
                        src={require('@assets/images/banner02@2x_blur.png')}
                    />
                }
            />
            {
                localStorage.getItem('channel') == 'taobao' ?
                    null :
                    <div className={styles.bth} onClick={() => props.selectTypeClick('shareModal')}></div>
            }
        </div>
    )
}

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { updateGlobalHomePageType, config, updateConfig, globalUser } = useContext(AppContext);
    const [powerList, setPowerList] = useState([]);
    const [mobile, setMobile] = useState()
    const [alipayOpen, setAlipayOpen] = useState(false)
    const [alipayItems, setAlipayItems] = useState()
    const [alipayDefaultSelectedIndex, setAlipayDefaultSelectedIndex] = useState(0)
    const [isPowerPackage, setIsPowerPackage] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)

    useEffect(() => {
        powerPackages()
        eventBus.emit('updateActivityInfo')
    }, [])

    useEffect(() => {
        if (location.hash == '#membership') {
            updateConfig({ loginHeadIndex: '2' })
        }
    }, [location])

    useEffect(() => {
        const target = document.getElementById('topView')
        if (target) target.scrollIntoView()
    }, [config.loginHeadIndex])

    function powerPackages() {
        return API.powerPackages({}).then((res) => {
            if (res.code == 0) {
                setPowerList(res.data)
                return res.data
            } else {
                message.error(res.message)
            }
        })
    }

    const loginClick = () => {
        if (localStorage.getItem('token')) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
            message.info('欢迎免费试用')
        } else {
            eventBus.emit('login', {
                mobile: mobile,
                callback: logged => {
                    if (logged) loginClick()
                    else console.log('取消了登录')
                }
            })
        }
    }

    const openModalToPayPlan = (item) => {
        if (item.level != 'free') {
            // 需要登录
            const status = Utils.checkLoginStatus(() => openModalToPayPlan(item))
            if (status) eventBus.emit('pc_prepay', item, false)
        } else {
            if (localStorage.getItem('token')) {
                message.info('欢迎免费试用')
                navigate("/home/homemain/model")
            } else {
                eventBus.emit('login', {
                    callback: logged => {
                        if (logged) openModalToPayPlan(item)
                        else console.log('取消了登录')
                    }
                })
            }
        }
    }

    const selectTypeClick = (value) => {
        if (value == 'accessories') {
            message.warning('暂未开放！')
            return false
        }

        if (value == 'cashbackActivity') {
            eventBus.emit('cashbackActivity') // 返现活动
        } else if (value == 'shareModal') {
            eventBus.emit('inviteUser')
        } else if (value == IMAGE_TYPE.MODEL) {   //真人图
            Utils.useroplog(IMAGE_TYPE.MODEL, 'function', 'navigation', { from: 'home' })
            document.title = 'PhotoStudio AI-AI模特'
            navigate("/home/homemain/model")
            Utils.clearClothesTaskCache()
        } else if (value == IMAGE_TYPE.CLOTHES) {     //衣服图
            Utils.useroplog(IMAGE_TYPE.CLOTHES, 'function', 'navigate', { from: 'home' })
            document.title = 'PhotoStudio AI-AI模特'
            navigate("home/homemain/clothes")
            Utils.clearClothesTaskCache()
        } else if (value == IMAGE_TYPE.SHOES) {     //衣服图
            Utils.useroplog(IMAGE_TYPE.SHOES, 'function', 'navigate', { from: 'home' })
            document.title = 'PhotoStudio AI-AI模特'
            navigate("home/homemain/shoesTryon")
            Utils.clearClothesTaskCache()
        } else if (value == IMAGE_TYPE.DRESSFORM) {   //人台图
            Utils.useroplog(IMAGE_TYPE.DRESSFORM, 'function', 'navigate', { from: 'home' })
            document.title = 'PhotoStudio AI-AI模特'
            navigate("home/homemain/dressform")
            Utils.clearClothesTaskCache()
        } else if (value == IMAGE_TYPE.MODEL_VIDEO) {    //模特视频
            Utils.useroplog(IMAGE_TYPE.MODEL_VIDEO, 'function', 'navigate', { from: 'home' })
            document.title = 'PhotoStudio AI-AI模特'
            navigate("home/homemain/model_video")
            Utils.clearClothesTaskCache()
        }
        else {
            Utils.useroplog(HOME_PAGE_TYPE.MERCHANDISE, 'function', 'navigation', { from: 'home' })
            document.title = 'PhotoStudio AI-AI商品图'
            navigate("/home/homemain/commodity")
            Utils.clearMerchandiseTaskCache()
        }
    }

    const toHome = () => {
        updateConfig({ loginHeadIndex: '1' })
    }

    // const onClick = () => {
    //     Utils.openFile2().then(file => {
    //         Utils.uploadFile(file).then(res => {
    //             console.log('uploadFile', res)
    //             console.log(`${res}?x-oss-process=image/resize,h_200/blur,r_4,s_4`)
    //         })
    //     })
    // }

    return (
        <div className={`${styles.Login}`}>
            {/* <Button onClick={onClick}>上传</Button> */}
            <div className={`${styles.login_show}`}>
                {
                    config.loginHeadIndex == 1 ? <Home selectTypeClick={selectTypeClick} mobile={mobile} setMobile={setMobile} loginClick={loginClick} /> :
                        config.loginHeadIndex == 2 ? <Page1 powerList={powerList} payClick={openModalToPayPlan} /> :
                            config.loginHeadIndex == 3 ? <Page2 /> :
                                null
                }
                <div className={styles.login_bottom}>
                    <Bottom toHome={toHome} />
                </div>
            </div>
            <InviteUserModal invitationCode={globalUser?.invitationCode} />
            <CahsbackModal />
        </div>
    )

}

export default Login